import { Tooltip } from 'antd'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'

export const paginationItemRender = (page, type, el) => {
  if (type === 'prev') {
    return <KeyboardArrowLeft />
  }

  if (type === 'next') {
    return <KeyboardArrowRight />
  }

  return el
}

export const renderEllipsisCell = label => {
  if (label === '-' || !label) {
    return '--'
  }

  if (label.length > 20) {
    return (
      <Tooltip title={label} placement='topLeft'>
        {label}
      </Tooltip>
    )
  }

  return label
}
